var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Divider',{staticClass:"w-25",attrs:{"align":"center"}},[_c('span',[_vm._v("LUB")])])
}
var staticRenderFns = []

export { render, staticRenderFns }